import userAgent from "src/constants/userAgent";

const isPlaywright = !!userAgent?.includes("Playwright");
export default isPlaywright;
